module.exports = __webpack_public_path__ + "static/media/sad.f06d51e9.png";